import { connect } from 'react-redux';

import CasinoRealityCheckModalContent from '../../../components/Casino/CasinoRealityCheckModalContent';

import { displayModal } from '@xanadu/ui-shared/modules/modal/actions';
import { getGameRealMode } from '../../../modules/vegas/actions';
import { updateCasinoRealityCheck, clearCasinoControlsErrors } from '../../../modules/casinoControls/actions';

const mapDispatchToProps = {
  displayModal,
  updateCasinoRealityCheck,
  clearCasinoControlsErrors,
  getGameRealMode,
};

function mapStateToProps(state) {
  return {
    editState: state.getIn(['casinoControls', 'editState']),
    editError: state.getIn(['casinoControls', 'editError']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CasinoRealityCheckModalContent);
